module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS42NjgiIGhlaWdodD0iMTIuODk5IiB2aWV3Qm94PSIwIDAgMTkuNjY4IDEyLjg5OSI+PHBhdGggZD0iTTIuMTAxIDEwLjczMkw5Ljg2IDEuODY1bTcuNzY5IDguODU2TDkuODcgMS44NTQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzVGODA4QyIgc3Ryb2tlLXdpZHRoPSIyLjIwMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/minimize.svg
// module id = 138
// module chunks = 0